/**
 * Target IDs for the `elevation` takeover.
 *
 * Single source of truth: imported only by `manifest.ts`. The runtime builder
 * expands manifest target groups into the legacy config maps.
 */

/** Simple home page IDs that receive elevation styling. */
export const shpIds = ['721bb5b3-3775-4add-a0bd-153d5fb4c41c'];

/** Menu section IDs (each has a distinct config in manifest.ts). */
export const menuSectionIds = {
  bkClassics: 'e896a667-807d-4ca2-be3a-f4ba990052af',
};

/** PDP/cart item IDs (each has a distinct config in manifest.ts). */
export const pdpItemIds = {
  whopper: 'eae5da38-28fb-4681-bcde-43abf07260eb',
  fries: '9427d6a0-1f55-4c08-97dd-c7c370507468',
  onionRings: '484f44d8-399f-4678-b8ee-96e109619da8',
  nuggets: 'a9a93d49-60f0-4c6f-b9ae-ae5cba45c403',
};
